import { FinanceType, TransactionItemType, TransactionType } from "@/enums/enums";
import { SettingTransactionRemarkModel } from "@/model/setting";

function SettingTransactionDueDate(settingTransactionDueDateRawList: any) {
  const _settingTransactionDueDate = [];
  if (settingTransactionDueDateRawList && settingTransactionDueDateRawList.length > 0) {
    for (const settingTransactionDueDateRaw of settingTransactionDueDateRawList) {
      _settingTransactionDueDate.push({
        transactionType: settingTransactionDueDateRaw.transactionType,
        financeType: settingTransactionDueDateRaw.financeType,
        day: settingTransactionDueDateRaw.day,
        settingDueDateType: settingTransactionDueDateRaw.settingDueDateType,
      });
    }
  }
  return _settingTransactionDueDate;
}

export function GetSettingTransactionDueDate(settingTransactionDueDateRawList: any) {
  return SettingTransactionDueDate(settingTransactionDueDateRawList);
}

export function ConvertToSettingTaxInvoice(_settingTaxInvoice: any) {
  let settingTaxInvoice = null;
  if (_settingTaxInvoice) {
    settingTaxInvoice = {
      invoiceTaxInvoiceType: _settingTaxInvoice.invoiceTaxInvoiceType,
      receiptTaxInvoiceType: _settingTaxInvoice.receiptTaxInvoiceType,
      canCreateTaxInvoiceNotVat: _settingTaxInvoice.canCreateTaxInvoiceNotVat,
    };
  }
  return settingTaxInvoice;
}

export function ConvertToSettingTransactionRemark(settingTransactionRemark: Array<SettingTransactionRemarkModel>) {
  const settingTransactionRemarkList: Array<SettingTransactionRemarkModel> = [];

  if (settingTransactionRemark && settingTransactionRemark.length > 0) {
    settingTransactionRemark.forEach((item) => {
      settingTransactionRemarkList.push({
        transactionType: item.transactionType ? item.transactionType : TransactionType.None,
        financeType: item.financeType ? item.financeType : FinanceType.None,
        transactionItemType: item.transactionItemType ? item.transactionItemType : TransactionItemType.None,
        remark: item.remark ? item.remark : "",
      });
    });
  }

  return settingTransactionRemarkList;
}
